import storage from '@/utils/localstorage'
// import { getConfig } from '@/api/core'

const ptype: any = {
  width_height: 'widthHeight',
  model: 'model',
  visual: 'visual',
  style: 'style',
  prompt: 'prompt'
}

const state = {
  data: [],
  widthHeight: [],
  model: [],
  visual: [],
  style: [],
  prompt: [],
  isGet: false
}
const mutations = {
  setData(state: any, data: any[]) {
    ;(state.data = data),
      data.length > 0 &&
        data.forEach((vo: any, index: number) => {
          const key = Object.keys(ptype).indexOf(vo.ptype)
          if (key != -1) {
            state[ptype[Object.keys(ptype)[key]]] = vo.nameValsList
          }
        })
  },
  setIsGet(state: any, data: any) {
    state.isGet = data
  }
}

const actions = {
  async getConfig({ commit }: any, userInfo: { phone: string; code: any }) {
    // const res: any = await getConfig(userInfo)
    // commit('setData', res)
    // commit('setIsGet', true)
    // return res
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
